import * as React from "react";
import {
  DeleteModal,
  ServerPaginatedTable,
  usePermission,
} from "../../../shared";
import { Link, useNavigate } from "react-router-dom";
import { useSuburbList } from "../hooks";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { sortItems } from "../../../utils";
import InputControl from "../../../shared/components/InputControl";

export const SuburbList = () => {
  const navigate = useNavigate();
  const {
    state,
    handleModal,
    handleDeleteSuburb,
    onSeachClear,
    onSearch,
    setPageSize,
    gotoPage,
  } = useSuburbList({
    isSuburb: true,
  });
  const { suburbDetails } = state;

  const isEditable = usePermission("city-modify");

  const isDeletable = usePermission("city-delete");

  const isCreateVisible = usePermission("city-create");

  const ActionButtons = ({ id, editAction, deleteAction }) => {
    return (
      <div className="action-buttons">
        {isDeletable && (
          <img alt="delete" onClick={deleteAction} src="/icons/ic_delete.svg" />
        )}
        {isEditable && (
          <Link to={`suburb/edit/${id}`}>
            <img alt="edit" src="/icons/ic_edit.svg" />
          </Link>
        )}
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Suburb Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "State Name",
        accessor: "state",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Post Code",
        accessor: "postcode",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Action",
        id: "action",
        disableSortBy: true,
        align: "right",
        disableGlobalFilter: true,
        accessor: (row, index) => {
          return (
            <ActionButtons
              id={row.id}
              editAction={() => navigate(`suburb/edit/${row.id}`)}
              deleteAction={() => handleModal("city", row.id)}
            />
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <ServerPaginatedTable
        columns={columns}
        data={suburbDetails.cities}
        isLoading={suburbDetails.isBusy}
        tableTitle="Suburb"
        defaultSearch={false}
        gotoPage={(e) => gotoPage(e, "suburb")}
        setPageSize={(e) => setPageSize(e, "suburb")}
        pagination={suburbDetails.pagination}
        sortByGlobal={[]}
        manualSortBy={false}
        // handleSort={handleSort}
        filterContent={
          <>
            <InputControl
              type="table-search"
              name="searchText"
              placeholder="Search"
              size="small"
              value={suburbDetails.filterApplied.search}
              onChange={(e) => onSearch(e, "suburbDetails")}
              onClear={() => onSeachClear("suburbDetails")}
            />
          </>
        }
        headerRightContent={
          <>
            {isCreateVisible && (
              <Button
                type="button"
                size="medium"
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => navigate("suburb/create")}
              >
                New Suburb
              </Button>
            )}
          </>
        }
      />
      <DeleteModal
        open={suburbDetails.isOpen}
        handleClose={() => handleModal("city")}
        onConfirm={() => handleDeleteSuburb()}
      />
    </>
  );
};
